module.exports = __webpack_public_path__ + "static/media/person.23c496f2.svg";